import React from 'react'
import { useLang } from '_metronic/i18n/Metronici18n'

interface Props {
	onCreate?: () => void
}

const Toolbar: React.FC<Props> = ({ onCreate }) => {
	const lang = useLang()

	return (
		<div className="w-fit-content">
			<button
				className="btn white-button text-kumopack-grey-900 fw-bold"
				onClick={onCreate}>
				<img src="/media/icons/kumopack/plus-grey.svg" alt="plus-grey" className="me-1" />
				{lang === 'en' ? 'Create' : 'สร้าง'}
			</button>
		</div>
	)
}

export default Toolbar
